import dynamic from 'next/dynamic';
import { TravelInsuranceProps } from './TravelInsurance.types';

export const TravelInsurance = dynamic<TravelInsuranceProps>(() => import('./TravelInsurance'));
